import Vue from 'vue'
Vue.directive('preventreclick', {
  inserted (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 2000)
      }
    })
  }
})


// WEBPACK FOOTER //
// ./src/plugin/preventReClick.js